import { getRespondentDeviceForensiq } from "../../api/Project";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../themes/components/Loader";
import { notify } from "../../themes/components/Notifications";
import MainLayout from "../../themes/layouts/Main";
import { isEmpty } from "lodash";
import Box from "@mui/material/Box";
import FormStickyHeader from "../../components/FormStickyHeader";

const DeviceForensiq: React.FC = () => {
  const { id } = useParams(),
    [data, setData] = useState<ProjectResponse | null>(null),
    [loading, setLoading] = useState<boolean>(true),
    [error, setError] = useState<boolean>(false);

  const getData = async () => {
    if (!id) return;
    const response: ProjectResponseDeviceForensiq = await getRespondentDeviceForensiq(id);
    const { result, messages } = response.projectResponseDeviceForensiq;
    if (!isEmpty(messages)) {
      notify(messages, "error");
      setError(true);
    } else if (result) {
      setData(result);
    }
    setLoading(false);
  };

  const getDeviceForensiq = () => {
    if (!data?.device_forensiq) return null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(data?.device_forensiq) || null;
  };

  const getKey = (key: string): string => {
    return key
      .replace(/([A-Z])/g, " $1") // Insert a space before each uppercase letter
      .replace(/(\d+)/g, " $1 ") // Add spaces around numbers
      .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
      .trim();
  };

  const getValue = (value: any): string => {
    if (null === value) return "-";
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return value.toString();
  };

  useEffect(() => {
    if (!data) {
      void getData();
    }
  });

  if (loading) {
    return <Loader />;
  }

  const deviceForensiq = getDeviceForensiq();

  return (
    <MainLayout>
      <FormStickyHeader>
        <p style={{ margin: 0 }}>Device Forensiq for respondent</p>
        <p style={{ fontSize: "medium", margin: 0 }}>Request Id: {data?.id}</p>
      </FormStickyHeader>
      <Box sx={{ px: 4, py: 2.8, mt: 12 }}>
        {(!deviceForensiq || !deviceForensiq?.forensic) && (
          <p>There isn't any Device Forensiq data for this respondent.</p>
        )}
        {error && <p>An unexpected error has occurred.</p>}
        {deviceForensiq && deviceForensiq.forensic && (
          <ul>
            {Object.entries(deviceForensiq.forensic).map(([key, value]) => (
              <li key={key}>
                {value && typeof value === "object" && Object.keys(value).length ? (
                  <ul style={{ paddingLeft: "2rem" }}>
                    {Object.entries(value).map(([childKey, childValue]) => (
                      <li key={childKey}>
                        <strong>{getKey(childKey)}</strong>: {getValue(childValue)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span>
                    <strong>{getKey(key)}</strong>: {getValue(value)}
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </Box>
    </MainLayout>
  );
};

export default DeviceForensiq;
